import { BrowserModule } from '@angular/platform-browser';
import { PesquisaShowComponent } from './../pesquisa-show/pesquisa-show.component';
import { HtmlPipe } from './../html.pipe';
import { ImgPipe } from './../img.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule, BrowserModule, FormsModule
  ],
  declarations: [
    ImgPipe, HtmlPipe, PesquisaShowComponent
  ],
  exports: [ImgPipe, HtmlPipe, PesquisaShowComponent]
})
export class CommunsModule { }



// WEBPACK FOOTER //
// ./src/app/communs/communs.module.ts